import { FC, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";

interface HowToUseModalProps {
  setShow: boolean;
  onClose: () => void;
  setHowSets: (value: boolean) => void;
}

const HowToUseModal: FC<HowToUseModalProps> = (props) => {
  const [show, setShow] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const location = useLocation();
  useEffect(() => {
    setCurrentStep(1);

    const howModal = localStorage.getItem("howToUseModal");
    if (location.pathname === "/") {
      props.onClose();
    } else {
      if (!howModal) {
        setShow(true);
        setCurrentStep(1);
        localStorage.setItem("howToUseModal", "");
      } else {
        setCurrentStep(1);
      }
    }
  }, [location]);

  const nextStep = () => {
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const closeModal = () => {
    setShow(false);
    props.onClose();
    localStorage.setItem("howToUseModal", "true");
  };

  return (
    <>
      <Modal
        size="lg"
        show={props.setShow || show}
        onHide={closeModal}
        keyboard={false}
        backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {currentStep === 1 && "Welcome to Virtual Personas!"}
            {currentStep === 2 && "How To Use Virtual Personas"}
            {currentStep === 3 && "Tips and Feedback"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentStep === 1 && (
            <div>
              <p className="mt-1">
                Enhance your communication and counselling skills through
                AI-powered patient interactions.
              </p>
              <p>
                Virtual Personas allows you to engage in realistic, dynamic
                conversations with virtual patients, exposing you to a wide
                range of hearing conditions and patient personalities.
              </p>

              <h5>Choose Your Simulation Mode</h5>
              <ul>
                <li>Supervised Simulation: For class-based sessions</li>
                <li>
                  Independent Simulation: For self-directed learning, anytime,
                  anywhere
                </li>
              </ul>
              {/* <h5>Free chat</h5>
              <ul>
                <li>Explore various topics</li>
                <li>Enhance interpersonal skills</li>
              </ul> */}
            </div>
          )}
          {currentStep === 2 && (
            <div>
              <h5>For Students</h5>
              <p>Supervised Simulation:</p>
              <ol>
                <li>Enter password provided for your lab session.</li>
                <li>Choose a virtual patient.</li>
                <li>
                  Take the patient's case history (use the microphone or type).
                </li>
                <li>
                  Press "Proceed to Hearing Test" (conduct audiometry
                  separately).
                </li>
                <li>
                  Return to Virtual Personas (password required to access pre-stored
                  test results).
                </li>
                <li>Explain results and provide recommendations.</li>
                <li>
                  Press "End Conversation" to receive a summary and optionally
                  save the transcript.
                </li>
                <li>Reflect on the interaction and seek educator guidance.</li>
              </ol>

              <p>Independent Simulation:</p>
              <ul>
                <li>Choose a virtual patient.</li>
                <li>Set patient traits to customise the interaction</li>
                <li>
                  Follow the same process as above (no passwords required).
                </li>
              </ul>

              <h5>For Educators/Admins</h5>
              <ul>
                <li>
                  Configure sessions and patient traits in the Admin Panel
                  (top-right menu).
                </li>
                <li>
                  Manage session settings, including customisation of virtual
                  patients.
                </li>
              </ul>
              {/* <p>
                <span>Remember:</span> Treat each AI interaction as you would a
                real patient.
              </p> */}
            </div>
          )}
          {currentStep === 3 && (
            <div>
              <h5>Tips for Success</h5>
              <ul>
                <li>Adapt your communication to each patient’s needs.</li>
                <li>
                  Experiment with different approaches to build confidence.
                </li>
                <li>
                  Reflect on each session - What worked well? What could you
                  improve?
                </li>
              </ul>
              <h5>Your Feedback Matters </h5>
              <p>Use the 'Feedback' tab to</p>
              <ul>
                <li>Suggest improvements</li>
                <li>Report issues</li>
                <li>Share your experience</li>
              </ul>
              <p>Step into the virtual clinic and welcome your next patient!</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* {currentStep > 1 && (
                        <Button variant="secondary" className="me-2" onClick={prevStep}>
                            Previous
                        </Button>
                    )} */}
          {currentStep < 3 ? (
            <Button variant="primary" onClick={nextStep}>
              Continue
            </Button>
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                closeModal();
                props.setHowSets(false);
                setCurrentStep(1);
              }}
            >
              Close
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default HowToUseModal;
